import { Text, Tooltip } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import * as NB from 'native-base';
import React, { useState } from 'react';

interface StatusBadgeProps {
  status: string;
  normalizedError?: string;
  bgColor?: string;
  color?: string;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  normalizedError,
  bgColor = 'neutral.lightest',
  color = 'neutral.darkest',
}) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const infoMessage = normalizedError?.trim();

  const statusBadge = (
    <NB.Box
      alignSelf="flex-start"
      px={Spacing['inline.nano']}
      py={Spacing['inset.quarck']}
      borderRadius={16}
      borderWidth={1}
      borderColor={color}
      bg={bgColor}>
      <Text variant="semibold" fontSize={Typography['fontsize.xs']} noOfLines={1} color={color}>
        {status}
      </Text>
    </NB.Box>
  );

  if (!infoMessage) {
    return statusBadge;
  }

  return (
    <Tooltip
      label={infoMessage}
      testID="report-status-error-tooltip"
      hasArrow
      placement="top"
      openDelay={100}
      maxW="280px"
      isOpen={isTooltipOpen}
      closeOnClick={false}
      onOpen={() => setIsTooltipOpen(true)}
      onClose={() => setIsTooltipOpen(false)}>
      <NB.Pressable
        testID="report-status-error-info-trigger"
        hitSlop={10}
        accessibilityLabel={infoMessage}
        accessibilityRole="button"
        alignSelf="flex-start"
        onPress={() => setIsTooltipOpen((open) => !open)}>
        {statusBadge}
      </NB.Pressable>
    </Tooltip>
  );
};
